import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { global } from 'src/app/global';

export interface ChatMessageRequest {
  conversationId?: number | null;
  message: string;
}

export interface ChatMessageResponse {
  conversationId: number;
  assistantMessage: string;
  createdAt: string;
  tokensUsed?: number;
}

export interface ConversationSummary {
  id: number;
  title: string;
  escalated: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ChatbotMessage {
  id: number;
  conversationId: number;
  role: 'USER' | 'ASSISTANT' | 'SYSTEM';
  content: string;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class ChatbotService {

  // Usamos global.url que apunta al backend (p. ej. http://localhost:9000/api/)
  private readonly baseUrl = global.url + 'chatbot';

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) {}

  private headers(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'licencia': this.cookieService.get('auth_token')
    });
  }

  sendMessage(request: ChatMessageRequest): Observable<ChatMessageResponse> {
    return this.http.post<ChatMessageResponse>(
      `${this.baseUrl}/message`,
      request,
      { headers: this.headers() }
    );
  }

  listConversations(): Observable<ConversationSummary[]> {
    return this.http.get<ConversationSummary[]>(
      `${this.baseUrl}/conversations`,
      { headers: this.headers() }
    );
  }

  getMessages(conversationId: number): Observable<ChatbotMessage[]> {
    return this.http.get<ChatbotMessage[]>(
      `${this.baseUrl}/conversations/${conversationId}/messages`,
      { headers: this.headers() }
    );
  }

  escalate(conversationId: number): Observable<void> {
    return this.http.post<void>(
      `${this.baseUrl}/conversations/${conversationId}/escalate`,
      null,
      { headers: this.headers() }
    );
  }
}

